/**
 * Authenticated User Bundle Configuration
 * Routes accessible to all authenticated users (TENANT_USER and above)
 */

export const USER_ROUTES = [
    'home',
    'select-workspace',
    'content',
    'deep-search',
    'skills',
    'skill',
    'reports',
    'report-preview',
    'export',
    'upload',
    'collection',
    'item',
    'summary',
    'settings',
    'billing',
    'credits',
    'migration',
    'bulk-edit',
    'keywords',
    'support',
    'support-architecture',
    'support-lms-integration',
    'support-release-notes',
    'support-user-guide',
    'support-external-player',
    'support-lms-portability',
    // METALARK-835: discoverable pending-invitations list for the
    // signed-in user. The single-token email-link flow lives in the
    // public bundle (accept-invitation.tag); this route is auth-gated
    // because it lists ALL invites addressed to the current account.
    'invitations'
] as const;

export type UserRoute = typeof USER_ROUTES[number];

export const USER_BUNDLE_PATH = '/assets/user';
export const BUNDLE_NAME = 'user';
export const REQUIRED_ROLES = ['TENANT_USER', 'TENANT_ADMIN', 'TENANT_VIEWER', 'RESOURCE_MANAGER', 'RESOURCE_CONTRIBUTOR', 'CUSTOMER_ADMIN', 'SYSTEM_ADMIN'];
